<template>
  <Loader :value="promises.fetch" class="settings-templates-loader">
    <template #default>
      <Card class="settings-templates">
        <template #default>
          <DataTable
            :value="items"
            :columns="[
              { id: 'name', label: $t('name') },
              { id: 'type', label: $tc('type', 1) },
              { id: 'categories', label: $tc('category', 2) },
              { id: 'default', label: $tc('default') },
              { id: 'template', label: $tc('theme'), size: '1fr' },
            ]"
            theme="border"
            :row-wrapper="
              item => ({
                component: 'router-link',
                props: {
                  to: { name: 'model-template-edit', params: { id: item.id } },
                  style: 'color: inherit',
                },
              })
            "
          >
            <template #name="{ item }">
              <span>{{ item.name }}</span>
            </template>

            <template #template="{ item }">
              <span>{{ getTemplate(item) }}</span>
            </template>

            <template #categories="{ item }">
              <Badge v-for="(item, index) in item.categories" :key="item + index" :value="item" />
            </template>

            <template #default="{ item }">
              <FontAwesomeIcon :icon="['fas', item.isDefault ? 'check' : 'x']" />
            </template>

            <template #type="{ item }">
              <span>{{ $tc(item.ofType.toLowerCase(), 1) }}</span>
            </template>

            <template #primary-row-actions="{ item }">
              <ButtonComponent
                tag="router-link"
                :to="{ name: 'model-template-edit', params: { id: item.id } }"
                v-tooltip="$t('edit')"
                :icon="['fal', 'pen']"
              />
            </template>
          </DataTable>
          <EmptyState
            v-if="!items.length"
            :icon="['fal', 'puzzle']"
            :title="$t('noX', { x: $tc('template', 2).toLowerCase() })"
          />
        </template>
        <template #footer>
          <ButtonComponent
            :label="$t('create')"
            tag="router-link"
            :to="{ name: 'model-template-create' }"
            :icon="['fal', 'plus']"
            theme="primary"
          />
        </template>
      </Card>
    </template>
  </Loader>
</template>

<script>
import { i18n } from '@/i18n'
import Store from '@/store'
import { mapState, mapActions } from 'vuex'
import Badge from '@/components/Badge'

import Card from '@/components/Card'
import DataTable from '@/components/DataTable'
import EmptyState from '@/components/EmptyState'

const meta = {
  skip: !Store.getters.isSuperadmin,
  order: 5,
  id: 'template',
  label: i18n.tc('template', 2),
  icon: ['fal', 'puzzle'],
}

export { meta }
export default {
  props: {
    isActive: Boolean,
  },
  watch: {
    isActive: {
      handler(val) {
        if (!val) return
        return this.fetch()
      },
      immediate: true,
    },
  },
  data() {
    return {}
  },

  computed: {
    ...mapState({
      themes(state) {
        return state.enums.Themes || []
      },
    }),
    ...mapState('ModelTemplate', ['items', 'promises']),
  },
  methods: {
    ...mapActions('ModelTemplate', ['fetch']),

    getTemplate(item) {
      let id = item.ofType === 'Project' ? item.data.theme : item.data.theme.template

      const theme = this.themes.find(t => t.value === id)

      if (!theme) return this.$t('custom')

      return theme.label
    },
  },
  components: {
    Card,
    DataTable,
    EmptyState,
    Badge,
  },
}
</script>
